
import { queryById } from "./queryById";
import { fetchSanityData } from "./sanity-api";

export const getSanityDataById = async <T>(id: string): Promise<T | null> => {
  const query = queryById(id);
  const data = await fetchSanityData<T>(query);
  return data.length ? data[0] : null;
};